export const production = {
    env: '[prod]',
    api: {
        base: '/api/api-config/api-request',
        compact: '/api/api-config/compact',
        authorize: '/api/authorize/authorize',
        login: '/api/authorize/login',
        resetPassword: '/api/authorize/reset-password',
        setNewPassword: '/api/authorize/setNewPassword',
        meta: '/api/api-config/meta',
    }
};



// WEBPACK FOOTER //
// ./src/environment/production.ts